import React from 'react';
import { useTickets } from '../../../contexts/TicketContext';

const STATUS_COLORS = {
    Open: '#1DA1F2',      // blue
    'On Hold': '#FBC02D', // yellow
    Escalated: '#E74C3C', // red
    Resolved: '#43B581'   // green
};

const statusList = [
    { key: 'Open', label: 'Open', color: STATUS_COLORS.Open },
    { key: 'On Hold', label: 'On Hold', color: STATUS_COLORS['On Hold'] },
    { key: 'Escalated', label: 'Escalated', color: STATUS_COLORS.Escalated },
    { key: 'Closed', label: 'Closed', color: STATUS_COLORS.Resolved },
];

const TotalTickets = ({ tickets: propTickets }) => {
    const { tickets: contextTickets } = useTickets();
    const tickets = propTickets || contextTickets;
    const total = tickets.length;
    const counts = statusList.map(s => tickets.filter(t => t.status === s.key).length);
    const barHeight = 130;
    const barWidth = 28;
    const totalCounts = counts.reduce((a, b) => a + b, 0) || 1;
    // Calculate each segment's height proportionally
    const heights = counts.map(count => Math.round((count / totalCounts) * barHeight));

    // For pixel-perfect stacking, adjust the last segment to fill the bar
    const heightSum = heights.reduce((a, b) => a + b, 0);
    if (heightSum !== barHeight) {
        heights[heights.length - 1] += (barHeight - heightSum);
    }

    return (
        <div className="flex flex-col items-center justify-between p-4 card-container rounded-md gap-3 w-full">
            <div className="flex flex-row items-center gap-4 justify-between w-full">
                <span className="text-lg text-font-secondary">Total Tickets</span>
                <span className="card-container text-xl font-bold text-font-secondary">{total}</span>
            </div>
            <div className="flex flex-row items-center w-full justify-between flex-1">
                <div className="flex flex-col justify-between h-full">
                    {statusList.map((status, idx) => (
                        <div key={status.key} className="flex flex-row items-center gap-2">
                            <span style={{ color: status.color }} className="text-xl font-bold">{counts[idx]}</span>
                            <span className="text-base text-font-secondary">{status.label}</span>
                        </div>
                    ))}
                </div>
                <div className="flex flex-col justify-end">
                    <div style={{ width: barWidth, height: barHeight, borderRadius: 8, background: '#232427' }} className="flex flex-col overflow-hidden">
                        {heights.map((h, idx) => (
                            <div
                                key={statusList[idx].key}
                                style={{ height: h, background: statusList[idx].color, width: '100%' }}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TotalTickets; 